import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { getLang } from 'i18n/config/LanguageDetector'
import { ReactElement } from 'react'
import { opt } from 'store/opt'
import { getShapeLabel, ItemData } from 'type/Inference'
import { Item } from 'type/Item'
import { OfferItem } from 'type/rec'

type ItemType = Item | OfferItem | ItemData

function extractBrand(item: ItemType): string | undefined {
  if ('brand' in item) return item.brand
  else return item.brand_name
}

function extractProduct(item: ItemType): string | undefined {
  if ('product' in item) return item.product
  else return item.product_name
}

export function renderItemTitle(item: ItemType, with_shape?: boolean): ReactElement | undefined {
  const { hide_name_for_en, combine } = opt.options
  const lang = getLang()
  const shape = with_shape ? getShapeLabel(item.dress_shape_type) : undefined
  const brand = extractBrand(item)
  const hide_name = lang === 'en' && hide_name_for_en && combine
  const product = !hide_name ? extractProduct(item) : undefined

  if (!brand && !product) return undefined

  return <Vertical>
    {shape && <Typo one size={9} medium upper>
      {shape}
    </Typo>}
    {shape && <Gap height={8} />}
    {brand && <Typo size={9} secondary upper balance>
      {brand}
    </Typo>}
    {product && <Typo size={11} medium upper balance clamp>
      {product}
    </Typo>}
  </Vertical>
}
